// src/App.js (修改版本)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import About from './pages/About';
import Auth from './pages/Auth';
import WritePost from './pages/WritePost';
import Archive from './pages/Archive';
import NotFound from './pages/NotFound';
import PostDetail from './pages/PostDetail';
import Header from './component/Header';
import Footer from './component/Footer';
import './App.css';

const { Content } = Layout;

// 受保护的路由组件
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/auth" replace />;
};

// 认证后的重定向组件
const AuthenticatedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  // 如果用户已登录且访问的是登录页面，则重定向到首页
  if (isAuthenticated && location.pathname === '/auth') {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

// 应用主组件
const AppContent = () => {
  const { isAuthenticated, logout } = useAuth();

  return (
    <Router>
      <Layout style={{ 
        minHeight: '100vh',
        overflow: 'hidden'  // 防止布局溢出
      }}>
        <Header isAuthenticated={isAuthenticated} logout={logout} />
        <Content style={{ 
          padding: '0',
          margin: 0,
          flex: 1,
          overflow: 'auto'  // 内容区域可滚动
        }}>
          <Routes>
            {/* 登录页面 - 如果已登录则重定向到首页 */}
            <Route path="/auth" element={
              <AuthenticatedRoute>
                <Auth />
              </AuthenticatedRoute>
            } />
            
            {/* 受保护的路由 */}
            <Route path="/" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/about" element={
              <ProtectedRoute>
                <About />
              </ProtectedRoute>
            } />
            <Route path="/write" element={
              <ProtectedRoute>
                <WritePost />
              </ProtectedRoute>
            } />
            <Route path="/archive" element={
              <ProtectedRoute>
                <Archive />
              </ProtectedRoute>
            } />
            <Route path="/post/:id" element={
              <ProtectedRoute>
                <PostDetail />
              </ProtectedRoute>
            } />
            
            {/* 未匹配路由 - 重定向到登录页 */}
            <Route path="*" element={
              <ProtectedRoute>
                <NotFound />
              </ProtectedRoute>
            } />
          </Routes>
        </Content>
        <Footer />
      </Layout>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;